import getCarrierName from 'modules/get-carrier-name/get-carrier-name';

export function buildAgencyNamesString(agencyCodes) {
  return new Intl.ListFormat('es', {
    type: 'conjunction',
  }).format((agencyCodes || []).map((code) => getCarrierName(code)) || []);
}
